@if (!isAddressMandatory()) {
  <div class="form-check mb-2 cbw-invoice-address-toggle">
    <input
      id="external_invoice_different_address"
      class="form-check-input"
      type="checkbox"
      role="checkbox"
      [checked]="checked()"
      (change)="onToggleChecked()"
      attr.aria-checked="{{ checked() }}"
    />
    <label class="form-check-label" for="external_invoice_different_address" id="label_external_invoice_different_address">
      {{ 'invoice_address.different_address' | translate }}
    </label>
  </div>
}

@if (showForm()) {
  <div class="cbw-invoice-address-title mb-2" role="heading" aria-level="3">
    {{ 'invoice_address.title' | translate }}
  </div>

  <div class="row">
    <div class="col-md-6 mb-1 cbw-invoice-address-firstname">
      <label class="mb-1" for="invoice_address_prename" id="label_invoice_address_prename">
        {{ 'form_fields.preName' | translate }} *
      </label>
      <input
        id="invoice_address_prename"
        name="invoice_address_prename"
        type="text"
        class="form-control"
        required
        [value]="prename()"
        (input)="prename.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('prename')"
        [class.is-invalid]="isFieldRequiredAndEmpty('prename')"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('prename') }}"
        aria-labelledby="label_invoice_address_prename"
        autocomplete="given-name"
      />
      @if (isFieldRequiredAndEmpty('prename')) {
        <div class="invalid-feedback" role="alert" aria-live="polite">
          {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang() | calioTranslateResolver: { text: ('form_fields.preName' | translate) }) }}
        </div>
      }
    </div>

    <div class="col-md-6 mb-1 cbw-invoice-address-lastname">
      <label class="mb-1" for="invoice_address_lastname" id="label_invoice_address_lastname">
        {{ 'form_fields.lastName' | translate }} *
      </label>
      <input
        id="invoice_address_lastname"
        name="invoice_address_lastname"
        type="text"
        class="form-control"
        required
        [value]="lastname()"
        (input)="lastname.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('lastname')"
        [class.is-invalid]="isFieldRequiredAndEmpty('lastname')"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('lastname') }}"
        aria-labelledby="label_invoice_address_lastname"
        autocomplete="family-name"
      />
      @if (isFieldRequiredAndEmpty('lastname')) {
        <div class="invalid-feedback" role="alert" aria-live="polite">
          {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang() | calioTranslateResolver: { text: ('form_fields.lastName' | translate) }) }}
        </div>
      }
    </div>
  </div>

  <div class="mb-1 cbw-invoice-address-company">
    <label class="mb-1" for="invoice_address_company_name" id="label_invoice_address_company_name">
      {{ 'personal_form.company' | translate }}
    </label>
    <input
      id="invoice_address_company_name"
      name="invoice_address_company_name"
      type="text"
      class="form-control"
      [value]="companyName()"
      (input)="companyName.set($any($event.target).value); onFieldChange()"
      aria-labelledby="label_invoice_address_company_name"
      autocomplete="organization"
    />
  </div>

  <div class="row">
    <div class="col-md-6 mb-1 cbw-invoice-address-street">
      <label class="mb-1" for="invoice_address_street" id="label_invoice_address_street">
        {{ 'form_fields.street' | translate }} *
      </label>
      <input
        id="invoice_address_street"
        name="invoice_address_street"
        type="text"
        class="form-control"
        required
        [value]="street()"
        (input)="street.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('street')"
        [class.is-invalid]="isFieldRequiredAndEmpty('street') || isStreetTouchedAndMissingNumber()"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('street') || isStreetTouchedAndMissingNumber() }}"
        aria-labelledby="label_invoice_address_street"
        autocomplete="street-address"
      />
      @if (isFieldRequiredAndEmpty('street')) {
        <div class="invalid-feedback" role="alert" aria-live="polite">
          {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang() | calioTranslateResolver: { text: ('form_fields.street' | translate) }) }}
        </div>
      } @else if (isStreetTouchedAndMissingNumber()) {
        <div class="invalid-feedback" role="alert" aria-live="polite">
          {{ 'invoice_address.street_error' | translate }}
        </div>
      }
    </div>

    <div class="col-md-6 mb-1 cbw-invoice-address-zip">
      <label class="mb-1" for="invoice_address_zip" id="label_invoice_address_zip">
        {{ 'form_fields.zip' | translate }} *
      </label>
      <input
        id="invoice_address_zip"
        name="invoice_address_zip"
        type="text"
        class="form-control"
        required
        [value]="zip()"
        (input)="zip.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('zip')"
        [class.is-invalid]="isFieldRequiredAndEmpty('zip')"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('zip') }}"
        aria-labelledby="label_invoice_address_zip"
        autocomplete="postal-code"
      />
      @if (isFieldRequiredAndEmpty('zip')) {
        <div class="invalid-feedback" role="alert" aria-live="polite">
          {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang() | calioTranslateResolver: { text: ('form_fields.zip' | translate) }) }}
        </div>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-1 cbw-invoice-address-city">
      <label class="mb-1" for="invoice_address_city" id="label_invoice_address_city">
        {{ 'form_fields.city' | translate }} *
      </label>
      <input
        id="invoice_address_city"
        name="invoice_address_city"
        type="text"
        class="form-control"
        required
        [value]="city()"
        (input)="city.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('city')"
        [class.is-invalid]="isFieldRequiredAndEmpty('city')"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('city') }}"
        aria-labelledby="label_invoice_address_city"
        autocomplete="address-level2"
      />
      @if (isFieldRequiredAndEmpty('city')) {
        <div class="invalid-feedback" role="alert" aria-live="polite">
          {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang() | calioTranslateResolver: { text: ('form_fields.city' | translate) }) }}
        </div>
      }
    </div>

    <div class="col-md-6 mb-1 cbw-invoice-address-country">
      <label class="mb-1" id="label_invoice_address_country">
        {{ 'personal_form.country' | translate }} *
      </label>
      <ng-select
        id="invoice_address_country"
        name="invoice_address_country"
        [ngModel]="countryId()"
        (ngModelChange)="onCountryChange($event)"
        [clearable]="false"
        [searchable]="true"
        [required]="true"
        attr.aria-required="true"
        aria-labelledby="label_invoice_address_country"
      >
        @for (option of (countries() | sortTranslationList: 'name': lang()); track option.id) {
          <ng-option [value]="option.id" [attr.aria-label]="option | translation: 'name': lang()">
            <div>
              <span>
                {{ option | translation: 'name': lang() }}
              </span>
            </div>
          </ng-option>
        }
      </ng-select>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-1 cbw-invoice-address-email">
      <label class="mb-1" for="invoice_address_email" id="label_invoice_address_email">
        {{ 'form_fields.email' | translate }} *
      </label>
      <input
        id="invoice_address_email"
        name="invoice_address_email"
        type="email"
        class="form-control"
        required
        [value]="email()"
        (input)="email.set($any($event.target).value); onFieldChange()"
        (blur)="markFieldTouched('email')"
        [class.is-invalid]="isFieldRequiredAndEmpty('email') || isEmailInvalidAndFilled()"
        attr.aria-required="true"
        attr.aria-invalid="{{ isFieldRequiredAndEmpty('email') || isEmailInvalidAndFilled() }}"
        aria-labelledby="label_invoice_address_email"
        autocomplete="email"
      />
      @if (isFieldRequiredAndEmpty('email') || isEmailInvalidAndFilled()) {
        <div class="invalid-feedback" role="alert" aria-live="polite">
          {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang() | calioTranslateResolver: { text: ('form_fields.email' | translate) }) }}
        </div>
      }
    </div>

    <div class="col-md-6 mb-1 cbw-invoice-address-phone">
      <label class="mb-1" for="invoice_address_phone" id="label_invoice_address_phone">
        {{ 'form_fields.phone' | translate }}
      </label>
      <!-- keyed on the country so picking another invoice country re-initialises the dial code -->
      @for (country of [phoneCountryCode()]; track country) {
        <app-calio-tel-input
          name="invoice_address_phone"
          [ngModel]="phone()"
          (ngModelChange)="onPhoneChange($event)"
          [ngModelOptions]="{ standalone: true }"
          [defaultCountry]="country"
          aria-labelledby="label_invoice_address_phone"
          autocomplete="tel"
        />
      }
    </div>
  </div>
}
